import React, { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Lixeira from "../../assets/icons/trash.svg";
import {ReactComponent as Perfil} from "../../assets/kinologyIcons/svg/patient.svg";
import {ReactComponent as LogoAzul} from "../../assets/kinologyIcons/svg/logoAzul.svg";
import {ReactComponent as Camera} from "../../assets/kinologyIcons/svg/camera.svg";
import {ReactComponent as Edit} from "../../assets/kinologyIcons/svg/edit.svg";
import { AddPacAvalActions } from "../../store/ducks/add_pac_aval";
import { Container } from "./styles";

const FotoPerfilMenor: React.FC = () => {
	const dispatch = useDispatch();
	const fileInputRef = React.useRef<HTMLInputElement | null>(null);

	const [img, setImg] = useState<any>();
	function getBase64(event: any) {

		const file = event.target.files[0];
		if (!file) return;
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onloadend = function () {
			setImg(reader.result);
			dispatch(AddPacAvalActions.set_avatar_eval_64(reader.result));
			dispatch(AddPacAvalActions.set_avatar_paci_64(reader.result));
		};
		reader.onerror = function (error) {
			console.log("Error: ", error);
		};
	}

	function deletePhoto(event: any) {
		event.target.value = null;
	}

	useEffect(() => {
		dispatch(AddPacAvalActions.set_photo(img));
	}, [img]);


	const is_open_paciente = useSelector(
		(state: any) => state.app.is_open_paciente
	);

	const removeFoto = (e: any) => {
		e.preventDefault();
		setImg("");
		dispatch(AddPacAvalActions.set_avatar_eval_64(""));
		dispatch(AddPacAvalActions.set_avatar_paci_64(""));
	}

	useEffect(() => {
		if (
			is_open_paciente?.USUARIO_FOTO != "" &&
			is_open_paciente?.USUARIO_FOTO != null &&
			img == null
		) {
			setImg(is_open_paciente?.USUARIO_FOTO);
		}
	}, []);

	const openFilePicker = (e: React.MouseEvent) => {
		e.preventDefault();
		fileInputRef.current?.click(); 
	};

	return (
		<Container>
			<input
				ref={fileInputRef}     
				id="img"
				type="file"
				onChange={getBase64}
				style={{ display: "none" }}
				accept="image/*"
			/>
			<label htmlFor="img" className="">
				<div className={`flex w-[100px] h-[100px] rounded-full items-center justify-center border-2 border-[#000E4B] relative cursor-pointer
					${img && `bg-[#00D084]`}	`}

				>
					{img
					 	?
							<LogoAzul />
						: <Perfil className={`w-[50%] h-[50%]`} color="#000E4B"/>
					}
					<div className={`flex p-1 items-center justify-center rounded-full bg-[#000E4B] absolute bottom-0 right-0`}
						  onClick={openFilePicker} 
					>
						{
							img
							? <Edit className={`w-[15px] h-[15px]`} color={'#FFFFFF'}/>
							: <Camera className={`w-[15px] h-[15px]`}/>
						}
						
					</div>
				</div>
			</label>
		</Container>
	);
};

export default memo(FotoPerfilMenor);
